import React from 'react'

import Layout from '../../components/Layout'

const ContractExpiration = () => {
	return (
		<Layout
			headerMode='fixed'
			title='Al Vencer el Contrato'
			description='GAIN informa al Asesor Inmobiliario para que este indique al propietario del valor actualizado de alquiler y venta del inmueble para que pueda así tomar la decisión más favorable a sus intereses.'>
			<section className='contract-expiration benefit-section fader'>
				<h2 className='benefit-section__title'>Al Vencer el Contrato</h2>
				<div className='benefit-section__content'>
					<h3>Avisamos a su agente inmobiliario</h3>
					<p>
						Dos meses antes del vencimiento del contrato, GAIN informa al Asesor Inmobiliario para
						que este indique al propietario del valor actualizado de alquiler y venta del inmueble
						para que pueda así tomar la decisión más favorable a sus intereses.
					</p>

					<h3>El secreto es la anticipación</h3>
					<p>
						Recordamos al inquilino el vencimiento del contrato con dos meses de anticipación. Lo
						notificamos para evitar malos entendidos y demoras en la negociación de un nuevo valor
						de alquiler o en la desocupación del inmueble.
					</p>

					<h3>Estado de liquidación de deuda</h3>
					<p>
						Antes de recibir el inmueble, preparamos un Estado de Liquidación de Deuda controlando
						todos los pagos a cargo del inquilino.
					</p>

					<h3>Recepción del inmueble</h3>
					<p>La recepción del inmueble se realiza cuidando los derechos de nuestros clientes.</p>

					<h3>Devolución del depósito de garantía</h3>
					<p>
						Luego de efectuadas las reparaciones y/o hechas las deducciones que correspondieren, nos
						encargamos de devolver el depósito en tiempo y forma.
					</p>

					<h3>Casos de conflicto:</h3>
					<p>Con GAIN son escasos los casos de conflicto que llegan a juicio.</p>
					<p>
						Las acciones ejecutadas “antes de contratar” y “durante la vigencia del contrato” nos
						aseguran la más rápida solución de los problemas.
					</p>
				</div>
			</section>
		</Layout>
	)
}

export default ContractExpiration
